<template>
  <div class="contactUs" style="margin-top:220px;">
    <div class="a_jc">
      <p><span>電話：+86 400-061-3311</span></p>
      <p><span>服務時間：9:00 - 18:00</span></p>
      <p><span>電子郵件：5x@verygrass.mo<br></span></p>
      <p><span>地址：澳門慕拉士大馬路175-179號建業工業大廈地下A座</span></p>
    </div>
    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
export default {
  name: 'ContactUs',
  components:{
     Nav
  },
  data () {
    return {
      tipsState:false,
      navState:true,
      titles: '聯系我們',
      titleChild:[{name:'',src:''}]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.contactUs{

  .a_jc {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    margin-bottom: 120px;

    p {
      color: #717171;
      text-indent: 35px;
      font-size: 16px;
      line-height: 35px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContactUs.vue